import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Zap, FileText, MapPin, BookOpen, CreditCard, Lock, Users, Star } from 'lucide-react';
export function HeroSection() {
  return <section className="relative pt-12 pb-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto flex flex-col items-center text-center" data-id="element-156">
      <motion.div initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} className="mb-8" data-id="element-157">
        <span className="text-gold-400 font-bold tracking-wider uppercase text-sm md:text-base flex items-center justify-center gap-2" data-id="element-158">
          🌎 MUNDORECURSOS™
        </span>
      </motion.div>

      <motion.h1 initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6,
      delay: 0.1
    }} className="text-5xl md:text-7xl lg:text-8xl font-extrabold text-white mb-8 leading-[1.05] tracking-tight" data-id="element-159">
        Dejá de sobrevivir. <br className="hidden md:block" data-id="element-160" />
        <span className="text-gold-400" data-id="element-161">
          Que la plata te sobre desde ahora.
        </span>
      </motion.h1>

      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.8,
      delay: 0.2
    }} className="relative w-full max-w-xl mx-auto mb-10" data-id="element-162">
        <div className="absolute inset-0 bg-gold-500/20 blur-3xl rounded-full" data-id="element-163"></div>
        <img src="https://cdn.magicpatterns.com/uploads/mumdUufXT6dN1pbpizsTm4/ChatGPT_Image_5_may_2026,_22_09_20.png" alt="MegaPack Menú Semanal Anti-Crisis" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-164" />
      </motion.div>

      <motion.p initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6,
      delay: 0.3
    }} className="text-lg md:text-2xl text-gold-400 max-w-3xl mx-auto mb-4 font-bold" data-id="element-165">
        El sistema N°1 para familias argentinas que quieren comer bien sin
        fundir el sueldo
      </motion.p>

      <motion.p initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6,
      delay: 0.4
    }} className="text-base md:text-lg text-blue-200/80 max-w-2xl mx-auto mb-10" data-id="element-166">
        Menús + Recetas + Listas de compra + Sustitutos listos para usar. Sin
        improvisar. Sin tirar comida. Sin llegar a fin de mes en cero.
      </motion.p>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6,
      delay: 0.5
    }} className="flex flex-wrap justify-center gap-3 md:gap-4 mb-10 text-sm md:text-base font-semibold" data-id="element-167">
        <div className="flex items-center gap-2 bg-navy-800/80 border border-navy-700 px-4 py-2 rounded-full text-white" data-id="element-168">
          <FileText className="w-4 h-4 text-gold-400" data-id="element-169" /> 100% PDF
        </div>
        <div className="flex items-center gap-2 bg-navy-800/80 border border-navy-700 px-4 py-2 rounded-full text-white" data-id="element-170">
          <Zap className="w-4 h-4 text-gold-400" data-id="element-171" /> Acceso en 5 min
        </div>
        <div className="flex items-center gap-2 bg-navy-800/80 border border-navy-700 px-4 py-2 rounded-full text-white" data-id="element-172">
          <MapPin className="w-4 h-4 text-gold-400" data-id="element-173" /> Para Argentina
        </div>
        <div className="flex items-center gap-2 bg-navy-800/80 border border-navy-700 px-4 py-2 rounded-full text-white" data-id="element-174">
          <BookOpen className="w-4 h-4 text-gold-400" data-id="element-175" /> 6 Tomos
        </div>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6,
      delay: 0.6
    }} className="w-full max-w-md mx-auto" data-id="element-176">
        <a href="#pricing" className="block w-full py-5 px-8 bg-gradient-to-r from-gold-500 to-gold-400 hover:from-gold-400 hover:to-gold-300 text-navy-900 font-extrabold text-lg md:text-xl rounded-2xl shadow-[0_0_30px_rgba(74,222,128,0.4)] hover:shadow-[0_0_40px_rgba(74,222,128,0.6)] transition-all transform hover:-translate-y-1" data-id="element-177">
          🌎 → QUIERO MI MEGAPACK AHORA
        </a>

        <div className="mt-6 flex flex-wrap justify-center items-center gap-4 text-sm font-medium text-blue-100" data-id="element-178">
          <div className="flex items-center gap-1" data-id="element-179">
            <Users className="w-4 h-4 text-gold-400" data-id="element-180" /> +1.200 familias
          </div>
          <span className="text-navy-700" data-id="element-181">|</span>
          <div data-id="element-182">6 Tomos</div>
          <span className="text-navy-700" data-id="element-183">|</span>
          <div data-id="element-184">6 Bonos</div>
          <span className="text-navy-700" data-id="element-185">|</span>
          <div className="flex items-center gap-1" data-id="element-186">
            4.9/5 <Star className="w-4 h-4 fill-gold-400 text-gold-400" data-id="element-187" />
          </div>
        </div>

        <div className="mt-6 flex flex-wrap justify-center items-center gap-3 text-xs md:text-sm text-blue-200/70" data-id="element-188">
          <div className="flex items-center gap-1" data-id="element-189">
            <Shield className="w-4 h-4" data-id="element-190" /> Garantía 7 días
          </div>
          <span data-id="element-191">|</span>
          <div className="flex items-center gap-1" data-id="element-192">
            <Lock className="w-4 h-4" data-id="element-193" /> Pago seguro
          </div>
          <span data-id="element-194">|</span>
          <div className="flex items-center gap-1" data-id="element-195">
            <CreditCard className="w-4 h-4" data-id="element-196" /> Mercado Pago
          </div>
        </div>
      </motion.div>
    </section>;
}